var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVolume = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 7.5v5h3.333L10 16.667V3.333L5.833 7.5zM13.75 10a3.75 3.75 0 0 0-2.083-3.358v6.708A3.728 3.728 0 0 0 13.75 10m-2.083-7.308v1.716A5.838 5.838 0 0 1 15.833 10a5.838 5.838 0 0 1-4.166 5.592v1.716A7.497 7.497 0 0 0 17.5 10a7.497 7.497 0 0 0-5.833-7.308"
  })));
};
export default SvgVolume;